// extracted by mini-css-extract-plugin
export default {"melodyVideo":"WR-z","isFullWidth":"XR-z","landingPageVideo":"YR-z","play":"ZR-z","iframeVideo":"_R-z","playHidden":"aS-z","fullwidth":"bS-z"};